(() => {
  if (window.MisfitPrintsReviewsCarousel) return;
  window.MisfitPrintsReviewsCarousel = true;

  const syncTrackHeight = (track) => {
    const cards = [...track.querySelectorAll('.jdgm-rev')];
    if (!cards.length || track.getBoundingClientRect().width < 1) return false;

    const trackRect = track.getBoundingClientRect();
    const visibleCards = cards.filter((card) => {
      const rect = card.getBoundingClientRect();
      return rect.right > trackRect.left + 1 && rect.left < trackRect.right - 1;
    });
    const measuredCards = visibleCards.length ? visibleCards : [cards[0]];
    const styles = getComputedStyle(track);
    const verticalPadding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
    const height = Math.max(...measuredCards.map((card) => card.getBoundingClientRect().height));
    if (height < 1) return false;

    track.style.height = `${Math.ceil(height + verticalPadding)}px`;
    return true;
  };

  const initializeTrack = (track) => {
    if (track.dataset.mpHeightInitialized === 'true') return true;
    if (!track.querySelector('.jdgm-rev')) return false;
    track.dataset.mpHeightInitialized = 'true';
    let frame;
    const scheduleSync = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        requestAnimationFrame(() => syncTrackHeight(track));
      });
    };
    track.addEventListener('scroll', scheduleSync, { passive: true });
    window.addEventListener('resize', scheduleSync);

    if ('IntersectionObserver' in window) {
      const intersectionObserver = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) scheduleSync();
        },
        { rootMargin: '300px 0px' }
      );
      intersectionObserver.observe(track);
    }

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(scheduleSync);
      resizeObserver.observe(track);
      track.querySelectorAll('.jdgm-rev').forEach((card) => resizeObserver.observe(card));
    }

    syncTrackHeight(track);
    scheduleSync();
    return true;
  };

  const initializeReviewTracks = () => {
    const tracks = document.querySelectorAll(
      '.mp-product-reviews .jdgm-all-reviews__body, .mp-product-reviews .jdgm-rev-widg__reviews'
    );
    return [...tracks].filter(initializeTrack).length;
  };

  const observer = new MutationObserver(() => {
    if (initializeReviewTracks()) observer.disconnect();
  });
  if (!initializeReviewTracks()) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  const handleControlClick = (event) => {
    const button = event.currentTarget;
    const section = button.closest('.mp-product-reviews');
    const track = section?.querySelector('.jdgm-all-reviews__body, .jdgm-rev-widg__reviews');
    const card = track?.querySelector('.jdgm-rev');
    if (!track || !card) return;

    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    const direction = button.hasAttribute('data-mp-reviews-prev') ? -1 : 1;
    track.scrollTo({
      left: track.scrollLeft + direction * (card.getBoundingClientRect().width + gap),
      behavior: 'smooth',
    });
  };

  document
    .querySelectorAll('.mp-product-reviews [data-mp-reviews-prev], .mp-product-reviews [data-mp-reviews-next]')
    .forEach((button) => button.addEventListener('click', handleControlClick));
})();
